import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import dayjs from "dayjs";

//ANT DESIGN IMPORTS
import {
  Layout,
  Col,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Divider,
  InputNumber,
  DatePicker,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { staticConfig } from "../glAndAccounting.config";
import { labelConfig } from "../glAndAccounting.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const EditGLAccountDemo = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const { state } = useLocation();

  const [accountTypeData, setAccountTypeData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [accountUsageData, setAccountUsageData] = useState([]);
  const [accountTagData, setAccountTagData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [manualEntriesAllowed, setManualEntriesAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [glDetail, setGlDetail] = useState([]);
  const [glAccTemplate, setGlAccTemplate] = useState({});
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [glCodeLengthLoading, setGlCodeLengthLoading] = useState(false);
  const [glCodeLength, setGlCodeLength] = useState(1);

  // Watch the account type field for changes
  const selectedAccountType = Form.useWatch("type", form);

  useEffect(() => {
    getTemplate();
    getDetailById(state);
    getGlcodeLength();
  }, []);

  // Effect to handle account type changes and update parent/tag data
  useEffect(() => {
    if (selectedAccountType && glAccTemplate && initialDataLoaded) {
      updateParentAndTagData(selectedAccountType);
      // Only clear fields if this is not the initial load
      if (!isInitialLoad) {
        form.setFieldsValue({
          parentId: undefined,
          tagId: undefined,
        });
      }
    }
  }, [selectedAccountType, glAccTemplate, initialDataLoaded, isInitialLoad]);

  const updateParentAndTagData = (accountTypeId) => {
    console.log(accountTypeId, "accountTypeId");
    console.log(accountTypeData, "accountTypeData");
    // Find the account type option to get its label
    const accountTypeOption = accountTypeData.find((option) => option.value === accountTypeId);

    if (!accountTypeOption) return;

    const accountTypeLabel = accountTypeOption.label.toLowerCase();
    console.log(accountTypeLabel, "d");

    let parentOptions = [];
    let tagOptions = [];

    switch (accountTypeLabel) {
      case "asset":
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;

      case "liability":
        parentOptions = getOptionsFromTemplate("liabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedLiabilitiesTagOptions");
        break;

      case "equity":
        parentOptions = getOptionsFromTemplate("equityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedEquityTagOptions");
        break;

      case "expense":
        parentOptions = getOptionsFromTemplate("expenseHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedExpensesTagOptions");
        break;

      case "income":
        parentOptions = getOptionsFromTemplate("incomeHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedIncomeTagOptions");
        break;

      case "contingent_asset":
        parentOptions = getOptionsFromTemplate("contingentAssetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedContingentAssetsTagOptions");
        break;

      case "contingent_liability":
        parentOptions = getOptionsFromTemplate("contingentLiabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedContingentLiabilitiesTagOptions");
        break;

      default:
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;
    }

    setParentData(parentOptions);
    setAccountTagData(tagOptions);
  };

  const getOptionsFromTemplate = (templateKey) => {
    console.log(templateKey, "templateKey");
    if (!glAccTemplate[templateKey]) return [];

    return glAccTemplate[templateKey].map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  function onCancel() {
    navigate("/gla0100-demo", { replace: false });
  }

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.GlAccount}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setGlDetail(objDetail);

        // SHOW THE SAVED DATA
        form.setFieldsValue({
          name: objDetail.name,
          glCode: objDetail.glCode,
          type: objDetail?.type?.id,
          parentId: objDetail?.parentId,
          usage: objDetail?.usage?.id,
          tagId: objDetail?.tagId?.id === 0 ? undefined : objDetail?.tagId?.id,
          status: objDetail?.status,
          currencyCode: objDetail?.currencyCode,
          description: objDetail?.description,
          manualEntriesAllowed: objDetail?.manualEntriesAllowed,
          shortName: objDetail?.shortName,
          category: objDetail?.category?.id,
          accountLevel: objDetail?.accountLevel?.id,
          accountStatus: objDetail?.accountStatus?.id,
          naturalBalance: objDetail?.naturalBalance?.id,
          regulatoryReportingCode: objDetail?.regulatoryReportingCode,
          ifrsClassification: objDetail?.ifrsClassification?.id,
          taxCategory: objDetail?.taxCategory?.id,
          approvedOnDate: objDetail?.approvedOnDate
            ? Array.isArray(objDetail.approvedOnDate)
              ? dayjs(BOM.FormatArrayDate(objDetail.approvedOnDate))
              : dayjs(objDetail.approvedOnDate)
            : undefined,
          approvedOnDat: objDetail?.closingDate
            ? Array.isArray(objDetail.closingDate)
              ? dayjs(BOM.FormatArrayDate(objDetail.closingDate))
              : dayjs(objDetail.closingDate)
            : undefined,
          multiCurrencyAllowed: objDetail?.multiCurrencyAllowed,
          revaluationRequired: objDetail?.revaluationRequired,
          revaluationGlAccountId: objDetail?.revaluationGlAccountId,
          postingAllowed: objDetail?.postingAllowed,
          debitAllowed: objDetail?.debitAllowed,
          creditAllowed: objDetail?.creditAllowed,
          maxTransactionLimit: objDetail?.maxTransactionLimit,
          batchPostingAllowed: objDetail?.batchPostingAllowed,
          openingBalance: objDetail?.openingBalance,
          minimumBalanceAllowed: objDetail?.minimumBalanceAllowed,
          maximumBalanceAllowed: objDetail?.maximumBalanceAllowed,
          overdraftAllowed: objDetail?.overdraftAllowed,
          controlAccountFlag: objDetail?.controlAccountFlag,
          reconcilationRequired: objDetail?.reconcilationRequired,
          externalReconciliationCode: objDetail?.externalReconciliationCode,
          settlementFlag: objDetail?.settlementFlag,
        });
        setManualEntriesAllowed(objDetail?.manualEntriesAllowed);
        setInitialDataLoaded(true);
        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GlAccountTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        const mockTemplate = {
          accountLevelOptions: [
            { id: 1, value: "Level 1" },
            { id: 2, value: "Level 2" },
          ],
          accountStatusOptions: [
            { id: 1, value: "Active" },
            { id: 2, value: "Inactive" },
          ],
          naturalBalanceOptions: [
            { id: 1, value: "Debit" },
            { id: 2, value: "Credit" },
          ],
          ifrsClassificationOptions: [
            { id: 1, value: "IFRS 1" },
            { id: 2, value: "IFRS 2" },
          ],
          taxCategoryOptions: [{ id: 1, value: "Tax Category 1" }],
          yesOrNo: staticConfig.yesOrNo,
          revaluationGlAccountOptions: [
            { value: "1001", label: "1001 - Revaluation Gains" },
            { value: "2001", label: "2001 - Revaluation Losses" },
            { value: "3001", label: "3001 - FX Revaluation" },
          ],
          controlAccountFlagOptions: [
            { value: "primary", label: "Primary" },
            { value: "secondary", label: "Secondary" },
            { value: "suspense", label: "Suspense" },
          ],
          externalSettlementAccount: [
            { value: "1001", label: "1001 - External Settlement Account" },
            { value: "2001", label: "2001 - External Settlement Account" },
            { value: "3001", label: "3001 - External Settlement Account" },
          ],
        };
        setGlAccTemplate({ ...res, ...mockTemplate });

        let tempAccountType = [];
        let tempAccountUsage = [];
        let tempCurrency = [];

        objList?.accountTypeOptions?.forEach((element) => {
          tempAccountType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.usageOptions?.forEach((element) => {
          tempAccountUsage.push({
            value: element.id,
            label: element.value,
          });
        });
        // Add "All" option first, then add other currencies
        tempCurrency.push({
          value: "ALL",
          label: "All Currencies",
        });
        objList?.currencies?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setAccountTypeData(tempAccountType);
        setAccountUsageData(tempAccountUsage);
        setCurrencyData(tempCurrency);
      }
    });
  }
  function getGlcodeLength() {
    setGlCodeLengthLoading(true);
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GlAccountCodeLengthConfig, (err, res) => {
      setGlCodeLengthLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        console.log(res);
        setGlCodeLength(res?.value ?? 0);
      }
    });
  }

  const handleManuelEntriesAllowed = (keyParam) => {
    setManualEntriesAllowed(keyParam);
  };

  const handleAccTypeChange = (value, option) => {
    // Set isInitialLoad to false when user manually changes account type
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  };
  const handleCurrencyChange = (value) => {
    setSelectedCurrency(value);
  };

  const onSubmit = (formValues) => {
    // Remove currencyCode from payload if "All" is selected
    if (selectedCurrency === "ALL" || formValues.currencyCode === "ALL") {
      delete formValues.currencyCode;
    }
    const url = `${definedApi.GlAccount}/${state.key}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.editGLCreatedMsg);
          navigate("/gla0100-demo");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0100-demo");
          setIsLoading(false);
        },
      },
    );
  };

  console.log(parentData, "parentData");
  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent pageTitle={labelConfig.editGLAccount} pageItems={staticConfig.editGLItems} />
      <Spin spinning={isLoading || glCodeLengthLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            {/* Section 1: GL Overview */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.glOverview}
              </Title>
            </Divider>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="type"
                    label={<Text strong>{appLabel.accountType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountType),
                      },
                    ]}
                  >
                    <Select
                      disabled={true}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.accountType)}
                      showSearch
                      options={accountTypeData}
                      onChange={handleAccTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="parentId"
                    label={<Text strong>{appLabel.parent}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.parent),
                      },
                    ]}
                  >
                    <Select
                      disabled={true}
                      showSearch
                      options={parentData}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                      allowClear
                      key={selectedAccountType}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="glCode"
                    label={<Text strong>{appLabel.GLCode}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.GLCode),
                      },
                      {
                        min: glCodeLength,
                        max: glCodeLength,
                        message: `GL Code must be ${glCodeLength} characters long`,
                      },
                    ]}
                  >
                    <Input
                      disabled={true}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.GLCode)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="name"
                    label={<Text strong>{labelConfig.glName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.glName),
                      },
                    ]}
                  >
                    <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.glName)} />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="shortName" label={<Text strong>{appLabel.shortName}</Text>}>
                    <Input placeholder={BOM.handlePlaceholderMsg(appLabel.shortName)} />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="usage" label={<Text strong>{appLabel.accountUsage}</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.accountUsage)}
                      showSearch
                      options={accountUsageData}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="tagId" label={<Text strong>{appLabel.tag}</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.tag)}
                      showSearch
                      options={accountTagData}
                      key={selectedAccountType}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="accountLevel"
                    label={<Text strong>{labelConfig.accountLevel}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.accountLevel)}
                      showSearch
                      options={glAccTemplate.accountLevelOptions?.map((o) => ({
                        value: o.id,
                        label: o.value,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="accountStatus"
                    label={<Text strong>{labelConfig.accountStatus}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.accountStatus)}
                      showSearch
                      options={glAccTemplate.accountStatusOptions?.map((o) => ({
                        value: o.id,
                        label: o.value,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="naturalBalance"
                    label={<Text strong>{labelConfig.naturalBalance}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.naturalBalance)}
                      showSearch
                      options={glAccTemplate.naturalBalanceOptions?.map((o) => ({
                        value: o.id,
                        label: o.value,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="regulatoryReportingCode"
                    label={<Text strong>{labelConfig.regulatoryReportingCode}</Text>}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.regulatoryReportingCode)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="ifrsClassification"
                    label={<Text strong>{labelConfig.ifrsClassification}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.ifrsClassification)}
                      showSearch
                      options={glAccTemplate.ifrsClassificationOptions?.map((o) => ({
                        value: o.id,
                        label: o.value,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="taxCategory"
                    label={<Text strong>{labelConfig.taxCategory}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.taxCategory)}
                      showSearch
                      options={glAccTemplate.taxCategoryOptions?.map((o) => ({
                        value: o.id,
                        label: o.value,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{labelConfig.openingDate}</Text>}
                    name="approvedOnDate"
                  >
                    <DatePicker
                      disabledDate={BOM.DisabledAfterCurrentDate}
                      style={{ width: "100%", height: 35 }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{labelConfig.closingDate}</Text>}
                    name="approvedOnDat"
                  >
                    <DatePicker
                      disabledDate={BOM.DisabledAfterCurrentDate}
                      style={{ width: "100%", height: 35 }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="manualEntriesAllowed"
                    label={<Text strong>{appLabel.manualEntriesAllowed}</Text>}
                  >
                    <Select
                      options={staticConfig.yesOrNo}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.manualEntriesAllowed)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="status" label={<Text strong>{appLabel.status}</Text>}>
                    <Select
                      options={statusData}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.status)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="description"
                    label={<Text strong>{appLabel.description}</Text>}
                    style={{ width: "100%" }}
                  >
                    <TextArea
                      showCount
                      maxLength={1000}
                      placeholder="Enter Account description"
                      style={{
                        height: 120,
                        resize: "none",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Section 2: Currency Configuration */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.currencyInfo}
              </Title>
            </Divider>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="currencyCode" label={<Text strong>Currency Code</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Currency Code")}
                      showSearch
                      options={currencyData}
                      allowClear
                      onChange={handleCurrencyChange}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                      optionRender={(option) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight: option.data.value === "ALL" ? "bold" : "normal",
                            color: option.data.value === "ALL" ? "#92428B" : "inherit",
                          }}
                        >
                          <span>{option.data.label}</span>
                          {option.data.value === "ALL" && (
                            <span style={{ fontSize: "12px", color: "#999" }}>
                              (No currency restriction)
                            </span>
                          )}
                        </div>
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="multiCurrencyAllowed"
                    label={<Text strong>Multi Currency Allowed</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Multi Currency Allowed")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="revaluationRequired"
                    label={<Text strong>Revaluation Required</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Revaluation Required")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="revaluationGlAccountId"
                    label={<Text strong>Revaluation GL Account</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Revaluation GL Account")}
                      showSearch
                      options={glAccTemplate.revaluationGlAccountOptions}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Section 3: Posting Controls */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                Posting Controls
              </Title>
            </Divider>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="postingAllowed" label={<Text strong>Posting Allowed</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Posting Allowed")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="debitAllowed" label={<Text strong>Debit Allowed</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Debit Allowed")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="creditAllowed" label={<Text strong>Credit Allowed</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Credit Allowed")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="maxTransactionLimit"
                    label={<Text strong>Maximum Transaction Limit</Text>}
                  >
                    <InputNumber
                      min={0}
                      placeholder={BOM.handlePlaceholderMsg("Maximum Transaction Limit")}
                      formatter={BOM.FormatAmount}
                      parser={BOM.ParseAmount}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="batchPostingAllowed"
                    label={<Text strong>Batch Posting Allowed</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Batch Posting Allowed")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Section 4: Balance Management */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                Balance Management
              </Title>
            </Divider>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="openingBalance" label={<Text strong>Opening Balance</Text>}>
                    <InputNumber
                      min={0}
                      placeholder={BOM.handlePlaceholderMsg("Opening Balance")}
                      formatter={BOM.FormatAmount}
                      parser={BOM.ParseAmount}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="minimumBalanceAllowed"
                    label={<Text strong>Minimum Balance Allowed</Text>}
                  >
                    <InputNumber
                      min={0}
                      placeholder={BOM.handlePlaceholderMsg("Minimum Balance Allowed")}
                      formatter={BOM.FormatAmount}
                      parser={BOM.ParseAmount}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="maximumBalanceAllowed"
                    label={<Text strong>Maximum Balance Allowed</Text>}
                  >
                    <InputNumber
                      min={0}
                      placeholder={BOM.handlePlaceholderMsg("Maximum Balance Allowed")}
                      formatter={BOM.FormatAmount}
                      parser={BOM.ParseAmount}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="overdraftAllowed" label={<Text strong>Overdraft Allowed</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Overdraft Allowed")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Section 5: Reconciliation & Control */}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                Reconciliation & Control
              </Title>
            </Divider>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="controlAccountFlag"
                    label={<Text strong>Control Account Flag</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Control Account Flag")}
                      options={glAccTemplate.controlAccountFlagOptions}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="reconcilationRequired"
                    label={<Text strong>Reconcilation Required</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Reconcilation Required")}
                      options={glAccTemplate.yesOrNo}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="externalReconciliationCode"
                    label={<Text strong>External Reconciliation Code</Text>}
                  >
                    <Input placeholder={BOM.handlePlaceholderMsg("External Reconciliation Code")} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="settlementFlag" label={<Text strong>Settlement Flag</Text>}>
                    <Select
                      placeholder={BOM.handlePlaceholderMsg("Settlement Flag")}
                      options={glAccTemplate.externalSettlementAccount}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Form.Item>
              <Row>
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGLAccountDemo);
